import axios from 'axios';
import apiConfig from "./apiConfig";
import qs from 'qs';
import { Children } from 'react';


function  commonApiFunction(params,  callback, callbackError) {
    axios.post(apiConfig.api_url, qs.stringify(params), { timeout: 30000})
        .then((response) => {

            callback(response);

        }).catch((error) => {

            //console.log(error)

            callbackError(error);

        })
}


function uploadImageFileFunction(formData, callback){
    // let fd = new FormData();
    // fd.append('file', file);
    // fd.append('action', action);
    
    axios({
      method: 'post',
      url: apiConfig.api_url,
      data: formData,
      headers: {'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        callback(response);
    }).catch(error => console.log(error))

}

 export default commonApiFunction
 export {uploadImageFileFunction}
